import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";

const FileDropzone = (props) => {
  const {
    title,
    fileType,
    response_seq,
    disabled,
    fileUploadAction,
    fileRemoveAction,
    viewFileAction,
    DropzoneContent,
    openFileManagerDialog,
    required,
    error,
    helperText,
    showAll,
    isNew,
    uploadable
  } = props;

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#FFFFFF",
    borderStyle: "dashed",
    backgroundColor: "#FFFFFF",
    color: "#000000",
    outline: "none",
    transition: "border .24s ease-in-out",
    // minHeight: theme.spacing(30)
  };

  const activeStyle = {
    borderColor: "blue",
  };
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    open,
  } = useDropzone({
    accept:
      "application/pdf, .dwg, image/*, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    noClick: true,
    disabled: disabled,
    // onDrop
    onDrop: (acceptedFiles) => {
      fileUploadAction(fileType, acceptedFiles, response_seq);
    },
  });

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <div className="container">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <DropzoneContent
          title={title}
          fileType={fileType}
          response_seq={response_seq}
          open={open}
          showAll={showAll}
          disabled={disabled}
          fileRemoveAction={fileRemoveAction}
          viewFileAction={viewFileAction}
          openFileManagerDialog={openFileManagerDialog}
          required={required}
          error={error}
          helperText={helperText}
          isNew={isNew}
          uploadable={uploadable}
        />
      </div>
    </div>
  );
};

export default FileDropzone;
